import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-48da5e30"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loan-dialog-wrap"
};
const _hoisted_2 = {
  class: "loan-dialog-header flex-row flex-items-center flex-row-space-between"
};
const _hoisted_3 = {
  class: "loan-dialog-content"
};
const _hoisted_4 = {
  class: "loan-dialog-footer flex-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Close = _resolveComponent("Close");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    "model-value": !!$props.content,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false,
    width: "440px",
    top: "36vh"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h4", null, _toDisplayString($setup.t('hint')), 1), _createVNode(_component_el_icon, {
      class: "close-icon ts",
      onClick: $setup.handleConfirm
    }, {
      default: _withCtx(() => [_createVNode(_component_Close)]),
      _: 1
    }, 8, ["onClick"])]), _createElementVNode("p", _hoisted_3, _toDisplayString($props.content), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
      class: "flex-1 confirm",
      type: "main",
      onClick: $setup.handleConfirm
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('iKnow')), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["model-value"])]);
}